import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  firstName: string;
  lastName: string;
};

export const SignUpFormName: FC<Props> = ({
  firstName,
  handleChange,
  lastName,
}) => (
  <div className="signup-form__group">
    <label
      htmlFor="input-firstname"
      className="signup-form__group__first signup-form__label"
    >
      <FormattedMessage id="signup/routes/user/form/SignUpFormName.tsx/1" />
      <input
        id="input-firstname"
        data-test-id="input-firstname"
        type="text"
        name="firstName"
        value={firstName}
        onChange={handleChange}
        spellCheck={false}
        autoComplete="given-name"
        required
      />
    </label>
    <label
      htmlFor="input-lastname"
      className="signup-form__group__second signup-form__label"
    >
      <FormattedMessage id="signup/routes/user/form/SignUpFormName.tsx/2" />
      <input
        id="input-lastname"
        data-test-id="input-lastname"
        type="text"
        name="lastName"
        value={lastName}
        onChange={handleChange}
        spellCheck={false}
        autoComplete="family-name"
        required
      />
    </label>
  </div>
);
